module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'male': fox.i18n.getTranslation('male', 'Male'),
				'female': fox.i18n.getTranslation('female', 'Female'),
				'select': fox.i18n.getTranslation('select', 'Select')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Profile_Editor', {

		VALIDEXTENSION: ['jpg', 'jpeg', 'bmp', 'png', 'tif', 'tiff'],

		configure: function (options) {
			this.successEmail = false;
			this.successDomain = false;
			this._isRejected = false;
			this._saveMugshot = false;
			this._saveAvatar = false;

			this.fieldGroups = {
				name: ['legalName', 'legalSurname'],
				birthdate: ['birthdateYear','birthdateMonth','birthdateDay'],
				idExpiryDate: ['idExpiryDateMonth','idExpiryDateDay','idExpiryDateYear']
			};

			options.selectors = {
				box: '#country-search-input',
				boxActive: 'mb-list-dropdown',
				container: '#search-list',
				span: '#placeholder-country',
				input: '[name="country"]',
				itemSearch: '.item-search-profile'
			};

			this.registerOptions('', {
				autoRender: false,

				requiredFields: ['domain', 'screenName', 'legalName', 'legalSurname', 'birthdate', 'idExpiryDate', 'gender', 'idNumber', 'country', 'state', 'city', 'zip', 'address', 'idFrontPagePhoto', 'facePhoto', 'faceIdPhoto'],
				alwaysActiveFields: ['screenName', 'password'],

				widgets: {
					'editor.widget': 'Aviary',

					profileSubmit: {
						widget: 'Profile_Submit',
						container: '.submit-block'
					},

					form: {
						widget: 'Form',
						formContainer: '.lt-col.content-block',
						autoSubmit: true,
						autoApply: true,
						formElements: {
							legalName: {
								element: '[name="legalName"]'
							},

							legalSurname: {
								element: '[name="legalSurname"]'
							},

							maidenName: {
								element: '[name="maidenName"]'
							},

							maidenSurname: {
								element: '[name="maidenSurname"]'
							},

							prevLegalName: {
								element: '[name="prevLegalName"]'
							},

							prevLegalSurname: {
								element: '[name="prevLegalSurname"]'
							},

							otherStageNames: {
								element: '[name="otherStageNames"]'
							},

							idNumber: {
								element: '[name="idNumber"]'
							},

							country: {
								element: {
									widget: 'SitePage_Profile_Search_Country',
									container: '#country-search-input',
									template: 'sitepage_profile_searchbox'
								}
							},

							state: {
								element: '[name="state"]'
							},

							city: {
								element: '[name="city"]'
							},

							zip: {
								element: '[name="zip"]'
							},

							address: {
								element: '[name="address"]'
							},

							idFrontPagePhoto: {element: {
								widget: 'Form_Element_FileUploader',
								container: '#placeholder-frontPage',
								autoApply: true,
								autoSubmit: true,
								checkFileExtension: true,
								validExtension: this.VALIDEXTENSION,
								input: {
									template: 'profile_upload_input',
									templateOptions: {
										name: 'frontPage'
									}
								},
								'progress.template': 'profile_upload_progress',
								exists: {
									template: 'profile_upload_exists',
									'handleWom.dom': {
										widget: '@this',
										event: 'addedToDom',
										callback: fox.bind(function() {
											this.postRenderPhoto('frontPage');
										}, this)
									}
								}
							}},
							idBackPagePhoto: {element: {
								widget: 'Form_Element_FileUploader',
								container: '#placeholder-backPage',
								autoApply: true,
								autoSubmit: true,
								checkFileExtension: true,
								validExtension: this.VALIDEXTENSION,
								input: {
									template: 'profile_upload_input',
									templateOptions: {
										name: 'backPage'
									}
								},
								'progress.template': 'profile_upload_progress',
								exists: {
									template: 'profile_upload_exists',
									'handleWom.dom': {
										widget: '@this',
										event: 'addedToDom',
										callback: fox.bind(function() {
											this.postRenderPhoto('backPage');
										}, this)
									}
								}
							}},
							idThirdPagePhoto: {element: {
								widget: 'Form_Element_FileUploader',
								container: '#placeholder-thirdPage',
								autoApply: true,
								autoSubmit: true,
								checkFileExtension: true,
								validExtension: this.VALIDEXTENSION,
								input: {
									template: 'profile_upload_input',
									templateOptions: {
										name: 'thirdPage'
									}
								},
								'progress.template': 'profile_upload_progress',
								exists: {
									template: 'profile_upload_exists',
									'handleWom.dom': {
										widget: '@this',
										event: 'addedToDom',
										callback: fox.bind(function() {
											this.postRenderPhoto('thirdPage');
										}, this)
									}
								}
							}},

							facePhoto: {element: {
								widget: 'Form_Element_FileUploader',
								container: '#placeholder-facePhoto',
								autoApply: true,
								autoSubmit: true,
								checkFileExtension: true,
								validExtension: this.VALIDEXTENSION,
								input: {
									template: 'profile_upload_input',
									templateOptions: {
										name: 'facePhoto'
									}
								},
								'progress.template': 'profile_upload_progress',
								exists: {
									template: 'profile_upload_exists',
									'handleWom.dom': {
										widget: '@this',
										event: 'addedToDom',
										callback: fox.bind(function() {
											this.postRenderPhoto('facePhoto');
										}, this)
									}
								}
							}},

							faceIdPhoto: {element: {
								widget: 'Form_Element_FileUploader',
								container: '#placeholder-faceIdPhoto',
								autoApply: true,
								autoSubmit: true,
								checkFileExtension: true,
								validExtension: this.VALIDEXTENSION,
								input: {
									template: 'profile_upload_input',
									templateOptions: {
										name: 'faceIdPhoto'
									}
								},
								'progress.template': 'profile_upload_progress',
								exists: {
									template: 'profile_upload_exists',
									'handleWom.dom': {
										widget: '@this',
										event: 'addedToDom',
										callback: fox.bind(function() {
											this.postRenderPhoto('faceIdPhoto');
										}, this)
									}
								}
							}}
						},
						'methods.sendMethod': 'POST',
						'methods.encodePost': true,
						hooks: {
							onPrepareValues: '@parent:prepareValues'
						}

					},

					gender: {
						widget: 'Control_Select',
						container: '.gender',
						'select.options': [
							{title: _.getTranslation('male'), value: 1},
							{title: _.getTranslation('female'), value: 2},
							{title: _.getTranslation('select'), value: '', selected: true, hidden: true}
						]
					},

					birthdateYear: {
						widget: 'Control_Select',
						container: '.birth-year',
						yearsLimit: [1940, new Date().getFullYear() - 18],
					},

					birthdateMonth: {
						widget: 'Control_Select',
						container: '.birth-month',
						months: true,
					},

					birthdateDay: {
						widget: 'Control_Select',
						container: '.birth-day',
						days: true,
					},
					idExpiryDateMonth: {
						widget: 'Control_Select',
						container: '.id-expiry-month',
						months: true
					},
					idExpiryDateDay: {
						widget: 'Control_Select',
						container: '.id-expiry-day',
						days: true
					},
					idExpiryDateYear: {
						widget: 'Control_Select',
						container: '.id-expiry-year',
						yearsLimit: [new Date().getFullYear(), new Date().getFullYear() + 50]
					},

					emailCheckApi: {
						widget: 'Api',
						method: 'registration.checkEmail'
					},

					domainCheckApi: {
						widget: 'Api',
						method: 'registration.checkDomain',
						httpMethod: 'post',
					}
				},
				handleWom: {
					formValuesChange: {
						widget: '#form',
						event: 'valueChange',
						callback: '_handleFormValuesChange'
					},

					emailCheck: {
						widget: '#emailCheckApi',
						event: 'success',
						callback: '_handleEmailCheck'
					},

					domainCheck: {
						widget: '#domainCheckApi',
						event: 'success',
						callback: '_handleDomainCheck'
					},

					emailValueChange: {
						widget: '#form',
						event: 'valueChanged_email',
						callback: 'checkEmail'
					},

					accountDataLoaded: {
						widget: '#form',
						event: 'defaultValuesLoaded',
						callback: 'checkAndRenderAccountState'
					},

					stateLoaded: {
						widget: '#profileSubmit',
						event: 'stateLoaded',
						callback: '_handleProfileStateLoad'
					},

					disablingToggle: {
						widget: '#form .Form_Element',
						event: ['disabled', 'enabled'],
						callback: '_handleDisablingToggle'
					},

					disablingToggleSelects: {
						widget: '.Control_Select',
						event: ['disabled', 'enabled'],
						callback: '_handleDisablingToggle'
					},

					disablingToggleCountry: {
						widget: '#form #country',
						event: ['disabled', 'enabled'],
						callback: '_handleDisablingToggle'
					},

					disablingTogglePhotos: {
						widget: '#form ~.Form_Element_FileUploaderInterface',
						event: ['disabled', 'enabled'],
						callback: '_handleDisablingToggle'
					}
				},

				handleDom: {
					submit: {
						targetWidget: '#profileSubmit',
						target: '.action.submit',
						event: 'click',
						callback: 'submit'
					},

					cancel: {
						targetWidget: '#profileSubmit',
						target: '.cancel-btn',
						event: 'click',
						callback: 'goToList'
					},

					generatePassword: {
						target: '.generate',
						event: 'click',
						callback: 'generatePassword'
					}
				}
			});

			this.registerOptions('#form .Form_Element_FileUploader', {
				'upload.widget': 'ClientFileUploaderBox',
				'upload.uploadType': 'clientUpload'
			});

			this.callParent('configure', arguments);
		},

		deactivate: function (argument) {
			this.toggleFromAutoSubmit(false);
			this._isRejected = false;
			this._disApprovedValues = {};
			this.callParent('deactivate', arguments);
		},

		running: function() {
			this.form = this.rwom1('#form');
			this.profileSubmit = this.rwom1('#profileSubmit');
			this.notices = fox.wom.selectFirst('~#throughNotifications');

			fox.each(this.wom('.Control_Select'), function (w) {
				this.handleEvent(w, 'change', '_handleSelectsChange');
			}, this);
		},

		activating: function(params) {
			if (this.switchModel(params.id) === false) {
				return this.callParent('activating', arguments);
			}
		},

		switchModel: function(id) {
			//no changes case
			if (this.modelId === id) {
				return false;
			}

			//add model case
			if (!id) {
				return false;
			}

			this.modelId = id;

			this.getData();
		},

		actionAvatar: function (el, alias, performer) {
			var imageAvaW, imageSrcW, editorParams, size, targetW, editor, form;

			editor = this.rwom1('#editor');
			form = this.rwom1('#form');
			this._saveAvatar = true;
			this._saveMugshot = true;

			imageAvaW = performer.getParent();

			imageSrcW = form.rwom1('#mugshot');

			if (alias === 'editMugshot') {
				size = '67:100';
				targetW = imageSrcW;
			} else {
				size = '150x150';
				targetW = imageAvaW;
			}

			editorParams = {
				initTool: 'crop',
				cropPresets: [[size, size]],
				cropPresetsStrict: true,
				cropPresetDefault: [size]
			};

			editor.show(imageSrcW.getOriginImage(), {
				callback: fox.bind(targetW.postProcess, targetW),
				width: size.split('x').shift(),
				height: size.split('x').pop()
			}, editorParams);
		},

		loadMugshot: function () {
			this._saveMugshot = true;
		},

		cleanFormField: function (el, alias, performer) {
			var elW;
			this._saveAvatar = true;
			this._saveMugshot = true;

			elW = performer.getParent();

			elW.setValue('');

			elW.switchEmbeddedWidget('input');

			return this;
		},

		checkAndRenderAccountState: function () {
			this.renderAccountForm();
		},

		renderAccountForm: function () {
			this.render();
			this.toggleFromAutoSubmit(true);
		},

		_handleSelectsChange: function (val, w, ev) {
			this.form.setValue(w.getAlias(), val);
		},
		onScreenShotPost: function (argument) {},

		postRenderPhoto: function(alias) {
			if (fox.isEmpty(this.submitData) || 
				fox.isEmpty(alias) || 
				!fox.inArray([1, 2, 3], this.submitData.approveState)) {
				return;
			}


			var placeHolder = fox.dom.selectFirst('#placeholder-' + alias, this.element),
				delElm = fox.dom.selectFirst('.close', placeHolder);

			if (fox.inArray([1, 2], this.submitData.approveState) || 
				(this.submitData.approveState === 3 && this.submitData.submitStatus[alias] === 1)) {
				placeHolder.removeChild(delElm);
			}
		},

		changeFieldLabel: function (elm, method) {
			var label = fox.dom.selectFirst('.fleft.label', elm.parentNode.parentNode.parentNode);

			if (!label) {
				return;
			}

			var data = this.fieldsLabels[method] || this.fieldsLabels['default'];

			if (data[elm.name]) {
				label.innerHTML = data[elm.name].label;
				elm.placeholder = data[elm.name].placeholder;
				if (!elm.value) {
					fox.dom.selectFirst('.placeholder', elm.parentNode).innerHTML = data[elm.name].placeholder;
				}
				
			}
		},

		checkEmail: function (str) {
			var emailRegexp = new RegExp(/^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/);
			var api = this.rwom1('#emailCheckApi');

			if (!emailRegexp.test(str)) {
				this.successEmail = false;
				console.warn('email not valid');
				this.toggleRequired('email', true, 'invalid');
				return;
			}

			this.toggleRequired('email', false);

			if (!api) {
				return;
			}

			api.send({email: str, xsid: ''}, false);
		},

		_handleEmailCheck: function (data) {

			if (data.answer.response.success.errors.length === 0) {
				console.warn('email passed');
				this.successEmail = true;
				this.toggleRequired('email', true);
				this.dispatchEvent('emailPassed');
				return;
			}

			console.error('email not passed');
			this.successEmail = false;
			this.toggleRequired('email', false, 'taken');
		},

		checkDomain: function (str) {
			var api = this.rwom1('#domainCheckApi');

			if (!api) {
				return;
			}

			api.send({domain: str, xsid: ''}, false);
		},

		_handleDomainCheck: function (data) {
			if (data.answer.response.success.errors.length === 0) {
				console.warn('domain passed');
				this.successDomain = true;
				this.toggleRequired('domain', true);
				this.dispatchEvent('domainPassed');
				return;
			}

			this.successDomain = false;
			this.toggleRequired('domain', false, 'taken');
			console.error('domain not passed');
		},

		_validateRequiredFields: function (values) {
			var requiredFields = this.getOption('requiredFields');
			var formValues = this.form._values || values;

			this.formIsValid = true;

			//console.log(formValues);

			for (var i = 0, n = requiredFields.length; i < n; i++) {
				var alias = requiredFields[i];

				this.toggleRequired(alias, true);

				if (fox.inArray(['birthdate', 'idExpiryDate'], alias)) {
					var date = this._getDate(alias);

					if (!date || date === '0000-00-00') {
						this.toggleRequired(alias, false);
						this.formIsValid = false;
					}
				}

				//console.log('validate', alias, formValues[alias]);
				if (!formValues[alias] || (fox.isObject(formValues[alias]) && !fox.getObjectKeys(formValues[alias]).length)) {
					this.toggleRequired(alias, false);
					this.formIsValid = false;
				}
			}
		},

		_validateRejectedFields: function (argument) {
			this.formIsValid = true;
		},

		validate: function (argument) {

			if (this._isRejected) {
				this._validateRejectedFields();
				return;
			}

			this._validateRequiredFields();
		},

		_submit: function () {
			if (!this.formIsValid) {
				return;
			}

			this.lockAllFields();

			this.profileSubmit.submit();
		},

		submit: function (argument) {
			this.rwom1('#form').collectData();
			
			this.hookWrapper('validate');

			this._submit();
		},

		_checkField: function (data) {
			var alias = data.alias;

			if (!fox.inArray(this.getOption('requiredFields'), alias)) {
				return;
			}

			if (!data.value.length) {
				this.toggleRequired(alias, false);
				return;
			}

			this.toggleRequired(alias, true);
		},

		toggleRequired: function (alias, state, msg) {
			msg = msg ? msg : 'required';
			var field = this.dom1('[data-row*="' + alias + '"]');

			if (!field) {
				return;
			}

			var req = fox.dom.selectFirst('.req', field);

			if (req) {
				req.innerHTML = msg;
			}

			fox.dom[state ? 'removeClass' : 'addClass']('warning', field);
		},

		toggleWarnig: function (alias, state) {
			var field = $('[data-row*="' + alias + '"]');

			if (!field) {
				return;
			}

			fox.dom[state ? 'removeClass' : 'addClass']('not-vailable', field);
		},

		prepareValues: function () {
			this.form._preparedValues = this.form._values;
			var birthdate = this._getDate('birthdate');
			var idExpiryDate = this._getDate('idExpiryDate');
			var mugshot = this.form._preparedValues.mugshot;
			var avatar = this.form._preparedValues.avatar;
			var phoneCode = this.form._preparedValues.phoneCode;
			var uploads = ['idFrontPagePhoto', 'idBackPagePhoto', 'idThirdPagePhoto', 'facePhoto', 'faceIdPhoto'];

			if (phoneCode && (phoneCode.charAt(0) === "+")) {
				this.form._preparedValues.phoneCode = "pls_" + phoneCode.substring(1);
			}

			if (birthdate) {
				this.form._preparedValues.birthdate = birthdate;
			}

			if (idExpiryDate) {
				this.form._preparedValues.idExpiryDate = idExpiryDate;
			}

			if (this._saveMugshot) {
				if (mugshot) {
					this.form._preparedValues.mugshot = window.encodeURIComponent(mugshot);
				}
				this._saveMugshot = false;
			} else {
				delete this.form._preparedValues.mugshot;
			}

			if (this._saveAvatar) {
				if (avatar) {
					this.form._preparedValues.avatar = window.encodeURIComponent(avatar);
				}
				this._saveAvatar = false;
			} else {
				delete this.form._preparedValues.avatar;
			}

			if (this.modelId) {
				this.form._preparedValues.id = this.modelId;
			}

			fox.each(uploads, function (alias) {
				var val = this.form._preparedValues[alias];
				if (val && fox.isEmpty(val)) {
					this.form._preparedValues[alias] = '';
				}
			}, this);
		},

		_getDate: function (alias) {
			var y = this.form.getValue(alias + 'Year');
			var m = this.form.getValue(alias + 'Month');
			var d = this.form.getValue(alias + 'Day');
			var currentDate = this.form.getValue(alias) || this.form._defaults[alias];

			if (y && m && d) {
				return y + '-' + m + '-' + d;
			}

			if (currentDate && currentDate.length) {
				return currentDate;
			}

			return false;
		},

		_parseDate: function (alias) {
			var date = this.form._defaults[alias];

			if (!date) {
				return;
			}

			var dateParts = date.split('-');

			if (dateParts.length !== 3) {
				return;
			}

			var month = parseInt(dateParts[1]);
			var year = parseInt(dateParts[0]);
			var day = parseInt(dateParts[2]);

			this.form._defaults[alias + 'Year'] = year;
			this.form._defaults[alias + 'Month'] = month < 10 && month > 0 ? '0' + month : month;
			this.form._defaults[alias + 'Day'] = day;

		},

		toggleFromAutoSubmit: function (state) {
			var form = this.wom1('#form');

			if (!form) {
				return;
			}

			form.autoSubmit = state;
			form.setOption('autoSubmit', state);
		},

		_handleProfileStateLoad: function () {
			var state = this.profileSubmit.getState();
			
			switch (state) {
				case 3:
					this.markFields();
					this.collectRejectedData();
					this._isRejected = true;
				break;

				case 1:
				case 2:
					this.lockAllFields();
				break;
			}
		
		},

		markFields: function (argument) {
			this.clearComments();
			this._insertComments();
			this._lockFields();
		},

		_insertComments: function () {
			fox.each(this.profileSubmit.getFields().disapproved, function (name) {
				this.insertComment(name, this.profileSubmit.getCommentsByFieldName(name));
				this.toggleFieldEdit(name, true);
			}, this);
		},

		_lockFields: function () {
			fox.each(this.profileSubmit.getFields().approved, function (name) {
				this.toggleFieldEdit(name, false);
			}, this);
		},

		lockAllFields: function (state) {
			var fieldsToLock = this.filterFields();

			state = fox.isEmpty(state) ? false : state;

			fox.each(fieldsToLock, function (name) {
				this.toggleFieldEdit(name, state);
			}, this);

			this.toggleFieldEdit('domain', state);
		},

		blockFields: function (fields, disable) {
			if (fox.isEmpty(fields)) {
				return;
			}

			disable = !!disable;

			fox.each(fields, function (name) {
				var $input = $(this.dom1('input[name="' + name + '"]'));

				if (!$input) {
					return;
				}

				$input.prop('disabled', disable);
				
				if (disable) {
					$input.css('opacity', '0.7').parent().addClass('inactive');
				} else {
					$input.css('opacity', '').parent().removeClass('inactive');
				}
				
			}, this);
		},

		blockFormFields: function (disable) {
			disable = !!disable;
			var formFields = fox.getObjectKeys(this.form.formSelectedElements);
			this.blockFields(formFields, disable);
			return disable;
		},

		insertComment: function (name, comment) {
			
			var field = $('.item-block:not(.payout-details-block) .property-item[data-row*="' + name + '"]')[0];

			//console.log(field, name);

			if (!field) {
				return;
			}

			var icon = fox.dom.selectFirst('.warning-icon', field);

			if (!icon) {
				return;
			}

			var msgBlock = fox.dom.selectFirst('.notice-block', icon);

			icon.style.display = 'block';

			if (comment) {
				msgBlock.style.display = 'block';
				msgBlock.innerHTML = comment || '';
			}
			
		},

		clearComments: function () {
			fox.each(fox.dom.select('.item-block:not(.payout-details-block) .property-item'), function (el) {
				var names = $(el).attr('data-row');
				var icon = fox.dom.selectFirst('.warning-icon', el);

				if (!icon) {
					return;
				}

				var msgBlock = fox.dom.selectFirst('.notice-block', icon);

				icon.style.display = 'none';
				msgBlock.style.display = 'none';
				msgBlock.innerHTML = '';

			}, this);
		},

		toggleFieldEdit: function (name, state) {
			var field = this.form.getFormElement(name);
			var selects = this.wom('.Control_Select');
			var action = state ? 'enable' : 'disable';

			if (name === 'birthdate') {
				fox.each(['birthdateMonth', 'birthdateDay', 'birthdateYear'], function (name) {
					this.toggleFieldEdit(name, state);
				}, this);

				return;
			}

			if (name === 'idExpiryDate') {
				fox.each(['idExpiryDateMonth', 'idExpiryDateDay', 'idExpiryDateYear'], function (name) {
					this.toggleFieldEdit(name, state);
				}, this);

				return;
			}

			if (name === 'country' || name.match('Photo')) {
				this.form._widgets[name][action]();

				return;
			}

			if (field) {
				var w = this.form._widgets[name];
				if (w && w[action]) {
					w[action]();
				}

				return;
			}

			fox.each(selects, function (select) {
				if (select.getAlias() === name) {
					if(select[action]) {
						select[action]();
					}
				}
			});
		},

		_handleDisablingToggle: function (el, el2, e) {
			var action = (e === 'disabled' ? 'addClass' : 'removeClass');

			if (!el) {
				return;
			}

			var alias = el.getAlias ? el.getAlias() : el2.getAlias();

			if (fox.inArray(['birthdateMonth', 'birthdateDay', 'birthdateYear'], alias)) {
				alias = 'birthdate';
			}

			if (fox.inArray(['idExpiryDateMonth', 'idExpiryDateDay', 'idExpiryDateYear'], alias)) {
				alias = 'idExpiryDate';
			}

			var row = $('.item-block:not(.payout-details-block) .property-item[data-row*="' + alias + '"]');

			if (row) {
				row[action]('locked');
			}

			if (fox.oop.instanceOf(el2, 'SitePage_Profile_Search_Country')) {
				fox.dom[action]('inactive', el.formElement.parentNode);

				return;
			}

			if (fox.oop.instanceOf(el2, 'Form_Element_FileUploader')) {
				//fox.dom[action]('inactive', el2.element[0].firstChild);
				//console.log('file', el2);
				return;
			}

			if (el.formElement) {

				if (el.formElement.parentNode) {
					fox.dom[action]('inactive', el.formElement.parentNode);
				}
				
				return;
			}
			
		},

		collectRejectedData: function () {
			this._disApprovedValues = {};
			var fields = this.profileSubmit.getFields().disapproved;

			fox.each(fields, function (name) {
				this._disApprovedValues[name] = this.form._defaults[name];
			}, this);
		},

		generatePassword: function () {
			this.form.setValue('password', this._generatePassword());
		},

		_generatePassword: function () {
			var chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz1234567890";
			var string_length = 12;
			var randomstring = '';
			var charCount = 0;
			var numCount = 0;
			var rnum;

			for (var i=0; i<string_length; i++) {
				// If random bit is 0, there are less than 3 digits already saved, and there are not already 5 characters saved, generate a numeric value.
				if((Math.floor(Math.random() * 2) === 0) && numCount < 3 || charCount >= 5) {
					rnum = Math.floor(Math.random() * 10);
					randomstring += rnum;
					numCount += 1;
				} else {
					// If any of the above criteria fail, go ahead and generate an alpha character from the chars string
					rnum = Math.floor(Math.random() * chars.length);
					randomstring += chars.substring(rnum,rnum+1);
					charCount += 1;
				}
			}

			return randomstring;
		},

		goToList: function (argument) {
			fox.site.gotoPage('models/approved');
		},

		filterFields: function () {
			var arr = [];
			var fields = this.profileSubmit.data.submitState;

			fox.each(fields, function (val, name) {
				if (fox.inArray(this.getOption('alwaysActiveFields'), name)) {
					return;
				}

				arr.push(name);
			}, this);

			return arr;
		},

		toggleButtonPosition: function (argument) {

		},

		_showNotice: function (noticeInfo, w, e) {
			fox.dom.addClass('css3-show',w.dom1('[notice-alias=' + noticeInfo.alias + ']'));
		},

		_handleFormValuesChange: function (data) {}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/model/profile/editor.js
// module id = 333
// module chunks = 2